// @ts-nocheck
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import "../LoginPage.css";
import "../LoginForm/LoginForm.css";
import genRequest from "includes/request";
import PasswordInput from "components/Inputs/PasswordInput";
import Button from "components/Button/Button";
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import LoadCont from "components/LoadCont/LoadCont";
import LoginFooter from "../LoginFooter/LoginFooter";

const PASS_REG = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?.,;!@$%^&*-]).{8,}$/;

/**
 * Read `?token=&email=` and replace the URL with the bare path.
 * Exported for tests.
 */
let consumed = null;
export function consumeResetLink() {
	// idempotent: StrictMode runs state initializers twice, the second run
	// would find the URL already cleaned
	if (!window.location.search && consumed) return consumed;
	const params = new URLSearchParams(window.location.search);
	const link = { token: params.get("token"), email: params.get("email") };
	consumed = link;
	if (window.location.search)
		window.history.replaceState(window.history.state, "", window.location.pathname);
	return link;
}

/**
 * Landing page of the link sent by `auth/forgot-password`:
 * /reset-password?token=...&email=...
 */
export default function ResetPasswordPage({ setLangCode }) {
	// Read the link once, then take the secret out of the address bar (history,
	// Sentry page URLs, Referer): later renders must not read window.location
	const [{ token, email }] = useState(() => consumeResetLink());
	useEffect(() => {
		// keep the page URL out of the Referer of every request it triggers
		const meta = document.createElement("meta");
		meta.name = "referrer";
		meta.content = "no-referrer";
		document.head.appendChild(meta);
		return () => meta.remove();
	}, []);
	const [newPass, setNewPass] = useState("");
	const [verif, setVerif] = useState("");
	const [errors, setErrors] = useState(false);
	const [isSending, setIsSending] = useState(false);
	const [isDone, setIsDone] = useState(false);

	function handleSubmit(e) {
		e.preventDefault();
		if (isSending) return false;
		let list = [];
		if (!PASS_REG.test(newPass))
			list.push(
				<div key="valid">
					{t("Password.NOT_VALID_ERROR")}<br />
					{t("Password.LENGTH_ERROR")}<br />
					{t("Password.CHARS_ERROR")}<br />
					{t("Password.SPEC_CHARS_ERROR")}
				</div>
			);
		if (newPass !== verif)
			list.push(<div key="match">{t("Password.NO_MATCH_ERROR")}</div>);
		setErrors(list.length ? list : false);
		if (list.length) return false;
		setIsSending(true);
		return genRequest(
			"auth/reset-password-with-token",
			{ email, token, newPassword: newPass },
			"post",
			{ skipReport: true }
		).then(
			() => {
				setIsSending(false);
				setIsDone(true);
			},
			() => {
				setIsSending(false);
				setErrors([<div key="link">{t("Login.RESET_LINK_ERROR")}</div>]);
			}
		);
	}

	let body;
	if (isSending) body = <LoadCont />;
	else if (isDone)
		body = (
			<div className="text-center">
				<div className="mb-2">{t("Login.RESET_DONE")}</div>
				<a className="btn btn-conn" href="/">{t("Login.BACK_HOME")}</a>
			</div>
		);
	else if (!token || !email)
		body = (
			<div className="text-center">
				<div className="mb-2">{t("Login.RESET_LINK_ERROR")}</div>
				<a className="btn btn-conn" href="/forget">{t("Login.FORGOTTEN_IDS")}</a>
			</div>
		);
	else
		body = (
			<form onSubmit={handleSubmit}>
				<div className="mb-2">{t("Login.RESET_MSG")}</div>
				<div className="inputs-wrapper">
					<label className="d-flex align-items-center mb-1">
						<FontAwesomeIcon icon={faLock} />
						<PasswordInput className="ms-1 w-100 login-input" placeholder={t("Password.NEW_PASS")} value={newPass} onChange={setNewPass} />
					</label>
					<label className="d-flex align-items-center">
						<FontAwesomeIcon icon={faLock} />
						<PasswordInput className="ms-1 w-100 login-input" placeholder={t("Password.CONFIRM_NEW_PASS")} value={verif} onChange={setVerif} />
					</label>
				</div>
				<ErrorsCont className="mt-3" errors={errors} listed={false} />
				<div className="d-flex align-items-center mt-3">
					<Button className="btn-conn" type="submit">{t("Password.SAVE_PASS")}</Button>
				</div>
			</form>
		);

	return (
		<div className="LoginPage LoginForm">
			<div className="login-wrapper">
				<div className="logo-cont"></div>
				<div className="form-cont">{body}</div>
			</div>
			<LoginFooter setLangCode={setLangCode} />
		</div>
	);
}
